import { useEffect, useRef } from 'react';
import { Outlet } from 'react-router-dom';
import { Box, useMediaQuery } from '@mui/material';
import Drawer from './Drawer';
import Header from './Header';
import Loader from 'components/Loader';
import { handlerDrawerOpen, useGetMenuMaster } from 'api/menu';
import { DRAWER_WIDTH, MINI_DRAWER_WIDTH } from 'config';
import './dashboard.css';

export default function DashboardLayout() {
  const { menuMaster, menuMasterLoading } = useGetMenuMaster();
  const mobile = useMediaQuery('(max-width:1023px)');
  const opened = useRef(false);
  useEffect(() => {
    handlerDrawerOpen(false);
  }, [mobile]);
  useEffect(() => {
    if (!menuMasterLoading) opened.current = true;
  }, [menuMasterLoading]);
  if (menuMasterLoading && !opened.current) return <Loader fullScreen />;
  const width = mobile ? 0 : menuMaster?.isDashboardDrawerOpened ? DRAWER_WIDTH : MINI_DRAWER_WIDTH;
  return (
    <Box className="xc-dashboard" sx={{ minHeight: '100dvh', bgcolor: '#f5f7fb', color: '#172b46' }}>
      <Header />
      <Drawer />
      <Box
        component="main"
        id="dashboard-main"
        sx={{
          ml: `${width}px`,
          pt: '76px',
          minWidth: 0,
          transition: 'margin-left .2s ease',
          '@media(prefers-reduced-motion: reduce)': { transition: 'none' }
        }}
      >
        <Box sx={{ p: { xs: 2, sm: 3, xl: 4 }, maxWidth: 1800, mx: 'auto' }}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}
